// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
/* Starter Custom Code
import {
    HasProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
*/
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect } from "react-redux";

/* Starter Custom Code - Start */
import {
    HasProductContext,
    ProductContext,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useContext } from "react";
import { css } from "styled-components";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";

export interface ProductUnitOfMeasureSelectProps extends Omit<OwnProps, keyof SelectPresentationProps> {}

export const useShowProductUnitOfMeasureSelect = () => {
    const { productSettings } = useSettingsCollection();
    const { product } = useContext(ProductContext);

    const productNotInCatalog = getBooleanProperty(product.properties.notInCatalog); // Store Custom Code
    return !(
        !productSettings?.alternateUnitsOfMeasure ||
        !product.unitOfMeasures ||
        product.unitOfMeasures.filter(uom => uom.unitOfMeasure).length <= 1 ||
        productNotInCatalog // Store Custom Code
    );
};
/* Starter Custom Code - End */

interface OwnProps extends SelectProps {
    labelOverride?: React.ReactNode;
    disabled?: boolean;
    extendedStyles?: SelectPresentationProps;
    // Starter Custom Code
    overridedStyles?: SelectPresentationProps;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasProductContext;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export const productUnitOfMeasureSelectStyles: SelectPresentationProps = {
    sizeVariant: "small",
    cssOverrides: {
        descriptionWrapper: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.descriptionWrapper}
        `,
        formField: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.formField}
        `,
        formInputWrapper: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.formInputWrapper}
        `,
        inputSelect: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
        `,
    },
};

const ProductUnitOfMeasureSelect: React.FC<Props> = ({
    productContext: {
        product: { unitOfMeasures },
        productInfo: { unitOfMeasure, productId },
        onUnitOfMeasureChanged,
    },
    disabled,
    productSettings,
    labelOverride,
    extendedStyles,
    overridedStyles, // Starter Custom Code
    ...otherProps
}) => {
    const styles = useExpandProps(productUnitOfMeasureSelectStyles, extendedStyles, overridedStyles); // Starter Custom Code

    if (!useShowProductUnitOfMeasureSelect() /* Starter Custom Code */) {
        return null;
    }

    const uomChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        if (!onUnitOfMeasureChanged) {
            logger.warn(`There was no onUnitOfMeasureChanged passed to the ProductContext for ${productId}`);
            return;
        }
        onUnitOfMeasureChanged(event.target.value);
    };

    return (
        <Select
            label={labelOverride ?? translate("U/M")}
            value={unitOfMeasure}
            onChange={uomChangeHandler}
            disabled={disabled}
            data-test-selector="product_unitOfMeasureSelect"
            {...styles}
            {...otherProps}
        >
            {/* Starter Custom Code - next line - "?" */}
            {unitOfMeasures?.map(uom => (
                <option key={uom.id.toString()} value={uom.unitOfMeasure}>
                    {uom.description ? uom.description : uom.unitOfMeasureDisplay}{" "}
                    {uom.qtyPerBaseUnitOfMeasure !== 1 ? `/${uom.qtyPerBaseUnitOfMeasure}` : ""}
                </option>
            ))}
        </Select>
    );
};

export default connect(mapStateToProps)(withProductContext(ProductUnitOfMeasureSelect));
